import React from 'react'
import './index.scss'
import { ProjectType } from '@utils/types'
import GalleryItem from '@components/projectGallery/galleryItem'
import useResizeWidth from '@hooks/useResizeWidth'

type Props = {
  content: ProjectType[]
}

const ProjectGallery = ({ content }: Props) => {
  const { width } = useResizeWidth()

  const renderGallery = () => {
    let sumWidth = 0
    let row = []
    let result = []
    content.forEach((node, index) => {
      if (
        node?.mainImage?.asset?.gatsbyImageData?.width >= width - 100 &&
        index !== content.length - 1
      ) {
        result.push(
          <div key={index} className="gallery-row">
            <GalleryItem project={node} />
          </div>,
        )
      } else {
        row.push(node)
        sumWidth += node?.mainImage?.asset?.gatsbyImageData?.width
      }
      if (sumWidth >= width - 100 || index === content.length - 1) {
        result.push(
          <div key={index} className="gallery-row">
            {row.map((item) => (
              <GalleryItem project={item} key={item.title} />
            ))}
          </div>,
        )
        sumWidth = 0
        row = []
      }
    })

    return result
  }

  return (
    <section className="grid-container" id="gallery">
      {renderGallery()}
    </section>
  )
}

export default ProjectGallery
